module.exports = __webpack_public_path__ + "img/settings.141923cc.svg";